import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { NgCollapsibleModule } from 'ng-collapsible';
import { TooltipModule, TooltipOptions } from 'ng2-tooltip-directive';
import { ClickOutsideModule } from 'ng4-click-outside';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgwWowModule } from 'ngx-wow';
import { AMLConversionService } from '../core/services/aml/aml-conversion.service';
import { SimulationStorageService } from '../core/services/simulation/storage/simulation-storage.service';
import { UsersService } from '../core/services/users/users.service';
import { RequiredErrorPipe } from '../modules/dashboard/shared/pipes/required-error/required-error.pipe';
import { CatenaryGeneratorComponent } from './components/catenary-generator/catenary-generator.component';
import { CatenaryToggleButtonComponent } from './components/catenary-generator/components/toggle-button/catenary-toggle-button.component';
import { CentralizerComponent } from './components/centralizer/centralizer.component';
import { CollapsibleComponent } from './components/collapsible/collapsible.component';
import { ContentDivisionComponent } from './components/content-division/content-division.component';
import { DeleteConfirmationModalComponent } from './components/delete-confirmation-modal/delete-confirmation-modal.component';
import { DraggableGripsComponent } from './components/draggable-grips/draggable-grips.component';
import { CheckboxFieldComponent } from './components/fields/checkbox-field/checkbox-field.component';
import { InputFieldComponent } from './components/fields/input-field/input-field.component';
import { UnitiesDropdownComponent } from './components/fields/input-field/unities-dropdown/unities-dropdown.component';
import { RadioFieldComponent } from './components/fields/radio-field/radio-field.component';
import { SelectFieldComponent } from './components/fields/select-field/select-field.component';
import { TextareaFieldComponent } from './components/fields/textarea-field/textarea-field.component';
import { LabelTabsComponent } from './components/label-tabs/label-tabs.component';
import { LabelledAreaComponent } from './components/labelled-area/labelled-area.component';
import { LoadingComponent } from './components/loading/loading.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { SearchFormComponent } from './components/search-form/search-form.component';
import { SimplePlotComponent } from './components/simple-plot/simple-plot.component';
import { SimulationUploaderComponent } from './components/simulation-uploader/simulation-uploader.component';
import { RangeSelectionDirective } from './components/table/range-selection/range-selection.directive';
import { TableHeaderComponent } from './components/table/table-header/table-header.component';
import { TableComponent } from './components/table/table.component';
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { AnimateOnceDirective } from './directives/animate-once/animate-once.directive';
import { DebounceClickDirective } from './directives/debounce-click/debounce-click.directive';
import { CustomTooltipOptions } from './options/custom-tooltip-options';
import { NumberToSciNotationPipe } from './pipes/number-to-sci-notation/number-to-sci-notation.pipe';
import { SnakeCaseToTitlePipe } from './pipes/snake-case-to-title/snake-case-to-title.pipe';

@NgModule({
  declarations: [
    CatenaryGeneratorComponent,
    InputFieldComponent,
    AnimateOnceDirective,
    RequiredErrorPipe,
    TextareaFieldComponent,
    SelectFieldComponent,
    TableComponent,
    LabelTabsComponent,
    CheckboxFieldComponent,
    RadioFieldComponent,
    NoResultsComponent,
    CatenaryToggleButtonComponent,
    SimulationUploaderComponent,
    UnitiesDropdownComponent,
    DraggableGripsComponent,
    PaginationComponent,
    SearchFormComponent,
    SimplePlotComponent,
    CentralizerComponent,
    TableHeaderComponent,
    CollapsibleComponent,
    RangeSelectionDirective,
    LabelledAreaComponent,
    ContentDivisionComponent,
    DeleteConfirmationModalComponent,
    ProgressBarComponent,
    LoadingComponent,
    NumberToSciNotationPipe,
    SnakeCaseToTitlePipe,
    ToggleButtonComponent,
    DebounceClickDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgxJsonViewerModule,
    NgwWowModule,
    NgSelectModule,
    ClickOutsideModule,
    NgxSmartModalModule.forRoot(),
    IMaskModule,
    TooltipModule.forRoot(CustomTooltipOptions as TooltipOptions),
    NgCollapsibleModule,
  ],
  exports: [
    NgwWowModule,
    ReactiveFormsModule,
    CatenaryGeneratorComponent,
    NgxJsonViewerModule,
    InputFieldComponent,
    AnimateOnceDirective,
    RequiredErrorPipe,
    TextareaFieldComponent,
    NgSelectModule,
    SelectFieldComponent,
    TableComponent,
    LabelTabsComponent,
    IMaskModule,
    NoResultsComponent,
    CheckboxFieldComponent,
    NgxSmartModalModule,
    TooltipModule,
    RadioFieldComponent,
    ClickOutsideModule,
    SimulationUploaderComponent,
    DraggableGripsComponent,
    PaginationComponent,
    SearchFormComponent,
    SimplePlotComponent,
    CentralizerComponent,
    UnitiesDropdownComponent,
    TableHeaderComponent,
    CollapsibleComponent,
    NgCollapsibleModule,
    RangeSelectionDirective,
    LabelledAreaComponent,
    ContentDivisionComponent,
    DeleteConfirmationModalComponent,
    ProgressBarComponent,
    LoadingComponent,
    NumberToSciNotationPipe,
    SnakeCaseToTitlePipe,
    ToggleButtonComponent,
    DebounceClickDirective,
  ],
  providers: [
    HttpClient,
    AMLConversionService,
    SimulationStorageService,
    UsersService,
    AnimateOnceDirective,
    RequiredErrorPipe,
    DecimalPipe,
  ],
})
export class SharedModule {}
